import { render } from "./MesasList.vue?vue&type=template&id=9b27e536&scoped=true"
import script from "./MesasList.vue?vue&type=script&lang=js"
export * from "./MesasList.vue?vue&type=script&lang=js"

import "./MesasList.vue?vue&type=style&index=0&id=9b27e536&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b27e536"]])

export default __exports__